import {Outlet} from 'react-router-dom';
import {Suspense} from 'react';
import Navigation from '../Navigation';
import {PageLoader} from '@/shared/ui/page-loader';
import {useState} from 'react';
import {cn} from '@/lib/utils';
import {Menu} from 'lucide-react';
import {ReminderToastProvider} from '@/contexts/ReminderToastContext';
import {ReminderNotificationsProvider} from '@/contexts/ReminderNotificationsContext';
import {useAuth} from '@/contexts/AuthContext';

const Layout = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  // Primary sidebar collapse (lg+). Persisted so it survives navigation/reload.
  const [collapsed, setCollapsed] = useState(
    () => typeof window !== 'undefined' && localStorage.getItem('nav_collapsed') === 'true',
  );
  const toggleCollapsed = () =>
    setCollapsed((c) => {
      const next = !c;
      try {
        localStorage.setItem('nav_collapsed', String(next));
      } catch {
        /* ignore */
      }
      return next;
    });
  const {user} = useAuth();

  return (
    <ReminderToastProvider>
    <ReminderNotificationsProvider userId={user?.id}>
    <div className="flex w-full min-w-0">
      <Navigation
        isMobileMenuOpen={isMobileMenuOpen}
        setIsMobileMenuOpen={setIsMobileMenuOpen}
        collapsed={collapsed}
        onToggleCollapse={toggleCollapsed}
      />
      <div
        className={cn(
          'flex-1 min-w-0 transition-all duration-300 overflow-x-auto',
          // Desktop margin matches the sidebar width (60px rail when collapsed).
          collapsed ? 'lg:ml-[60px]' : 'lg:ml-72',
          // Mobile is always full width (sidebar overlays as a drawer).
          isMobileMenuOpen && 'ml-0'
        )}
      >
        <div className="lg:hidden bg-card border-b border-border p-4 flex items-center justify-between">
          <button
            onClick={() => setIsMobileMenuOpen(true)}
            className="p-2 rounded-lg hover:bg-accent"
          >
            <Menu className="h-5 w-5" />
          </button>
          {/* <h1 className="text-lg font-bold text-foreground">PM Portal</h1> */}
          <div className="w-9" /> {/* Spacer for centering */}
        </div>
        {/* Consistent container for all pages - ensures same width across all tabs */}
        {/* No max-width constraint - content fills available space to prevent gaps at any zoom level */}
        {/* Use box-border to ensure padding is included in width calculation */}
        <div className="w-full min-w-0 box-border px-4 sm:px-6 py-6 overflow-x-auto">
          <Suspense fallback={<PageLoader message="Loading..." minHeight="min-h-[400px]" />}>
            <Outlet />
          </Suspense>
        </div>
      </div>
    </div>
    </ReminderNotificationsProvider>
    </ReminderToastProvider>
  );
};

export default Layout;
